/**
 * Auth module configuration constants
 */

// Basic form validation rules
export const VALIDATION_RULES = {
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  MIN_PASSWORD_LENGTH: 8,
  REQUIRED_FIELDS: {
    LOGIN: ['email', 'password']
  }
};
export const FORM_TYPES = {
  LOGIN: 'login',
  REGISTER: 'register',
  FORGOT: 'forgot'
};

// Investment types
// Auth flow states
export const AUTH_STATES = {
  CHOICE: 'choice',
  SENTINEL: 'sentinel',
  SIGNALS: 'signals'
};

// Error messages
export const ERROR_MESSAGES = {
  REQUIRED_FIELD: 'This field is required',
  INVALID_EMAIL: 'Please enter a valid email address',
  PASSWORD_TOO_SHORT: `Password must be at least ${VALIDATION_RULES.MIN_PASSWORD_LENGTH} characters`,
  SUBMISSION_FAILED: 'Failed to submit form. Please try again.',
  EMAIL_SEND_FAILED: 'Failed to send email. Please try again.'
};
